<template>
    <div class="article-box">
        <div class="blogs left-box">
            <div class="white-bg lanmu">
                <img src="https://www.yangqq.com/d/file/qiyewangzhanzhizuo/2019-03-12/83e93c682ec3cd324b3f99c69cb868ea.png">
                <h1><a href="index.html">{{ category }}</a></h1>
                <p>
                    网页制作软件有哪些?哪个好?我们为大家提供了很多好的网页制作软件，如：Dreamweaver,网页三剑客,HTML代码编辑器等最好的网页设计软件免费下载。青于蓝免费提供dreamweaver,网页制作,网页制作软件下载</p>

            </div>
            <div class="clear blank"></div>
            <div class="blogs-box white-bg">
                <div class="news-title"> <span class="h-nav">
<a href="html/index.html">网页制作</a><a href="ftp/index.html">FTP工具</a><a href="soft/index.html">编程软件</a><a
                        href="jQuery/index.html">jQuery插件</a></span>
                    <h2>{{ category }}</h2>
                </div>
                <div class="download-list">
                    <ul>

                        <li>
                            <h3><a href="html/16.html">腾讯QQ下载v9.1.1.24953 最新版</a></h3>
                            <i><img src="../../assets/images/ex01.png" alt="腾讯QQ下载v9.1.1.24953 最新版"></i>
                            <p>提供QQ下载2018正式版官方免费下载，经过不断的更新，现在的PC端QQ已经是非常成熟的聊天软件了，新版本带来了全新的界面，集成的聊天窗口吸收了QQforMac的界面元素</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/16.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/90.html">腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</a></h3>
                            <i><img src="../../assets/images/ex02.png" alt="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/90.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/91.html">营销qq2019最新版 v2.21.2927 官方版</a></h3>
                            <i><img src="http://menhu.yangqq.com/d/file/p/2019/05-04/77858802ef0b011a8066feb4fa6048f1.jpg"
                                    alt="营销qq2019最新版 v2.21.2927 官方版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/91.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/92.html">Wine QQ国际版 UbuntuKylin版 官方版</a></h3>
                            <i><img src="../../assets/images/ex03.png" alt="Wine QQ国际版 UbuntuKylin版 官方版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/92.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/93.html">企业QQ2019电脑版 v2.0 最新版</a></h3>
                            <i><img src="../../assets/images/ex04.png" alt="企业QQ2019电脑版 v2.0 最新版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/93.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/94.html">Smart QQ下载 2.0 官方版</a></h3>
                            <i><img src="../../assets/images/ex05.png" alt="Smart QQ下载 2.0 官方版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/94.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/95.html">腾讯QQ下载v9.1.1.24953 最新版</a></h3>
                            <i><img src="../../assets/images/ex06.png" alt="腾讯QQ下载v9.1.1.24953 最新版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/95.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/96.html">腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版</a></h3>
                            <i><img src="../../assets/images/ex07.png" alt="腾讯tim(QQ简洁版) v2.3.1.20994 官方最新版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/96.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/97.html">营销qq2019最新版 v2.21.2927 官方版</a></h3>
                            <i><img src="../../assets/images/ex08.png" alt="营销qq2019最新版 v2.21.2927 官方版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/97.html" target="_blank">安全下载</a></span></li>
                        <li>
                            <h3><a href="html/98.html">hbuilder v9.1.29官网版</a></h3>
                            <i><img src="../../assets/images/ex09.png" alt="hbuilder v9.1.29官网版"></i>
                            <p>
                                HBuilderX是编辑器和IDE的完美结合，HBuilderX是HBuilder的下一代产品，体积小巧，启动秒开，默认包包含优秀的字处理能力，创新众多其他编辑器不具备的高效字处理模型。</p>
                            <span class="down-info">大小：<em>261M</em>更新时间：<em><font
                                    color="red">2019-05-04</font></em></span><span class="down-bth"><a
                                href="html/98.html" target="_blank">安全下载</a></span></li>
                    </ul>
                </div>
                <div class="pagelist"></div>
            </div>
        </div>
        <aside class="side-section right-box">
            <recommend></recommend>
            <div class="blank clear"></div>
            <down-sort></down-sort>
            <div class="blank clear"></div>
            <tags-box></tags-box>
            <img-ad></img-ad>
            <liked></liked>
        </aside>
    </div>
</template>

<script>
    import Recommend from "./Recommend";
    import DownSort from "./DownSort";
    import ImgAd from "../ads/ImgAd";
    import Liked from "./Liked";
    import TagsBox from "../tags/TagsBox";
    export default {
        name: "Index",
        components: {TagsBox, Liked, ImgAd, DownSort, Recommend},
        data() {
            return {
                category: ''
            }
        },
        watch: {
            $route (to, from) {
                this.category = this.$route.params.category
            }
        }
    }
</script>

<style scoped>

</style>